// Course Type constants

// Course Types
const types = {
    SCHEDULED: {
        name: 'Scheduled',
        label: 'Scheduled',
    },
    UNSCHEDULED: {
        name: 'Additional',
        label: 'Additional',
    },
}

const courseTypes = Object.fromEntries(
    Object.entries(types).map(([key, value]) => [key, key])
        .sort() //Sort alphabetically
)

// Human-readable strings
const courseTypeNames = Object.fromEntries(
    Object.entries(types).map(([key, value]) => [key, value.name])
        .sort() //Sort alphabetically
)

// Course type labels
const courseTypeLabels = Object.fromEntries(
    Object.entries(types).map(([key, value]) => [key, value.label])
        .sort() //Sort alphabetically
)

// Only additional course types (all course that are not 'SCHEDULED')
const courseTypesUnscheduled = Object.fromEntries(
    Object.entries(courseTypes).filter(([key, value]) => value !== courseTypes.SCHEDULED)
        .sort(([key1], [key2]) => courseTypeLabels[key1].localeCompare(courseTypeLabels[key2])) // Sort by labels
)

Object.freeze(courseTypes);
Object.freeze(courseTypeNames);
Object.freeze(courseTypesUnscheduled);

export default courseTypes;
export {
    courseTypes as COURSE_TYPES,
    courseTypeNames as COURSE_TYPE_NAMES,
    courseTypesUnscheduled as COURSE_TYPES_UNSCHEDULED,
}